import React from 'react';
import { Heart } from 'lucide-react';
import UnifiedHeader from '@/components/layout/UnifiedHeader';
import { useCurrentNavItem } from '@/hooks/useCurrentNavItem';

interface ConnectionsHeaderProps {
  activeTab: 'sent' | 'received' | 'matched' | 'views';
  sentCount: number;
  receivedCount: number;
  matchedCount: number;
  viewsCount?: number;
}

const ConnectionsHeader: React.FC<ConnectionsHeaderProps> = ({
  activeTab,
  sentCount,
  receivedCount,
  matchedCount,
  viewsCount = 0
}) => {
  const currentNavItem = useCurrentNavItem();
  const Icon = currentNavItem?.icon || Heart;
  
  const getSubtitle = () => {
    switch (activeTab) {
      case 'received':
        return `${receivedCount} ${receivedCount === 1 ? 'pessoa curtiu' : 'pessoas curtiram'} você`;
      case 'sent':
        return `Você curtiu ${sentCount} ${sentCount === 1 ? 'pessoa' : 'pessoas'}`;
      case 'matched':
        return `${matchedCount} ${matchedCount === 1 ? 'conexão ativa' : 'conexões ativas'}`;
      case 'views':
        return `${viewsCount} ${viewsCount === 1 ? 'pessoa viu' : 'pessoas viram'} seu perfil`;
      default:
        return currentNavItem?.description || 'Gerencie suas conexões';
    }
  };

  return (
    <UnifiedHeader
      title={currentNavItem?.label || "Likes"}
      subtitle={getSubtitle()}
      icon={Icon}
      iconColor="text-white"
      iconBgColor="bg-luxury-pinkBright border-luxury-pinkBright"
    />
  );
};

export default ConnectionsHeader;
